package diana.soleil.design.iraniancanadienbazzar.core.common

/**
 * Runtime build metadata, supplied by each platform entry point (which has access to its build config)
 * and provided into DI. Read by the Developer Menu and the debug-gated dev-menu entry point.
 *
 * - Android sets these from `BuildConfig` (`VERSION_NAME`, `VERSION_CODE`, `FIREBASE_ENV`, `DEBUG`).
 * - iOS/web pass their equivalents (or [Unknown] until wired).
 *
 * [isDebug] replaces the old temporary `isDebugBuild()` stub: it now reflects the real build type.
 */
data class AppBuildInfo(
    val versionName: String,
    val versionCode: String,
    val firebaseEnv: String,
    val isDebug: Boolean,
) {
    companion object {
        /** Safe fallback for previews / entry points that haven't supplied real values. */
        val Unknown = AppBuildInfo(
            versionName = "0.0.0",
            versionCode = "0",
            firebaseEnv = "unknown",
            isDebug = false,
        )
    }
}
